import { render } from "./DeleteUserModal.vue?vue&type=template&id=779ea95b"
import script from "./DeleteUserModal.vue?vue&type=script&lang=js"
export * from "./DeleteUserModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
